const serverRenderingUtils = require('anchor-website-common/helpers/serverRenderingUtils');

const APP_INIT = '@@index/APP_INIT';
const SESSION_NAME = 'anchorpw_s';
const ASSETS_PATH = 'https://d12xoj7p9moygp.cloudfront.net/';
const DEFAULT_PODCAST_IMAGE = `${ASSETS_PATH}images/default-podcast-image.png`;
const BUILD_ASSETS_PATH = 'https://d1rx8vrt2hn1hc.cloudfront.net/builds/';

// wrapped version of keymaster (not server-safe)
const assignKey = serverRenderingUtils.windowUndefined()
  ? function() {}
  : require('keymaster');

module.exports = Object.assign({}, serverRenderingUtils, {
  isIOS: serverRenderingUtils.isIOS,
  APP_INIT,
  assignKey,
  doHideGetAppButton,
  ASSETS_PATH,
  BUILD_ASSETS_PATH,
  DEFAULT_PODCAST_IMAGE,
  getBaseUrl,
  getBlobUrlCreator,
  getDateWithoutHours,
  getEpisodeImage,
  isClipperPath,
  isEmbedPath,
  isPodcastDashboardPath,
  calculatePayoutFee,
  SESSION_NAME,
  LANGUAGES: [
    { label: 'Afrikaans', value: 'af' },
    { label: 'Albanian', value: 'sq' },
    { label: 'Arabic', value: 'ar' },
    { label: 'Basque', value: 'eu' },
    { label: 'Belarusian', value: 'be' },
    { label: 'Bulgarian', value: 'bg' },
    { label: 'Catalan', value: 'ca' },
    { label: 'Chinese (Simplified)', value: 'zh-cn' },
    { label: 'Chinese (Traditional)', value: 'zh-tw' },
    { label: 'Croatian', value: 'hr' },
    { label: 'Czech', value: 'cs' },
    { label: 'Danish', value: 'da' },
    { label: 'Dutch', value: 'nl' },
    { label: 'Dutch (Belgium)', value: 'nl-be' },
    { label: 'Dutch (Netherlands)', value: 'nl-nl' },
    { label: 'English', value: 'en' },
    { label: 'English (Australia)', value: 'en-au' },
    { label: 'English (Belize)', value: 'en-bz' },
    { label: 'English (Canada)', value: 'en-ca' },
    { label: 'English (Ireland)', value: 'en-ie' },
    { label: 'English (Jamaica)', value: 'en-jm' },
    { label: 'English (New Zealand)', value: 'en-nz' },
    { label: 'English (Phillipines)', value: 'en-ph' },
    { label: 'English (South Africa)', value: 'en-za' },
    { label: 'English (Trinidad)', value: 'en-tt' },
    { label: 'English (United Kingdom)', value: 'en-gb' },
    { label: 'English (United States)', value: 'en-us' },
    { label: 'English (Zimbabwe)', value: 'en-zw' },
    { label: 'Estonian', value: 'et' },
    { label: 'Faeroese', value: 'fo' },
    { label: 'Finnish', value: 'fi' },
    { label: 'French', value: 'fr' },
    { label: 'French (Belgium)', value: 'fr-be' },
    { label: 'French (Canada)', value: 'fr-ca' },
    { label: 'French (France)', value: 'fr-fr' },
    { label: 'French (Luxembourg)', value: 'fr-lu' },
    { label: 'French (Monaco)', value: 'fr-mc' },
    { label: 'French (Switzerland)', value: 'fr-ch' },
    { label: 'Galician', value: 'gl' },
    { label: 'Gaelic', value: 'gd' },
    { label: 'German', value: 'de' },
    { label: 'German (Austria)', value: 'de-at' },
    { label: 'German (Germany)', value: 'de-de' },
    { label: 'German (Liechtenstein)', value: 'de-li' },
    { label: 'German (Luxembourg)', value: 'de-lu' },
    { label: 'German (Switzerland)', value: 'de-ch' },
    { label: 'Greek', value: 'el' },
    { label: 'Hawaiian', value: 'haw' },
    { label: 'Hungarian', value: 'hu' },
    { label: 'Icelandic', value: 'is' },
    { label: 'Indonesian', value: 'in' },
    { label: 'Irish', value: 'ga' },
    { label: 'Italian', value: 'it' },
    { label: 'Italian (Italy)', value: 'it-it' },
    { label: 'Italian (Switzerland)', value: 'it-ch' },
    { label: 'Japanese', value: 'ja' },
    { label: 'Korean', value: 'ko' },
    { label: 'Macedonian', value: 'mk' },
    { label: 'Norwegian', value: 'no' },
    { label: 'Polish', value: 'pl' },
    { label: 'Portuguese', value: 'pt' },
    { label: 'Portuguese (Brazil)', value: 'pt-br' },
    { label: 'Portuguese (Portugal)', value: 'pt-pt' },
    { label: 'Romanian', value: 'ro' },
    { label: 'Romanian (Moldova)', value: 'ro-mo' },
    { label: 'Romanian (Romania)', value: 'ro-ro' },
    { label: 'Russian', value: 'ru' },
    { label: 'Russian (Moldova)', value: 'ru-mo' },
    { label: 'Russian (Russia)', value: 'ru-ru' },
    { label: 'Serbian', value: 'sr' },
    { label: 'Slovak', value: 'sk' },
    { label: 'Slovenian', value: 'sl' },
    { label: 'Spanish', value: 'es' },
    { label: 'Spanish (Argentina)', value: 'es-ar' },
    { label: 'Spanish (Bolivia)', value: 'es-bo' },
    { label: 'Spanish (Chile)', value: 'es-cl' },
    { label: 'Spanish (Colombia)', value: 'es-co' },
    { label: 'Spanish (Costa Rica)', value: 'es-cr' },
    { label: 'Spanish (Dominican Republic)', value: 'es-do' },
    { label: 'Spanish (Ecuador)', value: 'es-ec' },
    { label: 'Spanish (El Salvador)', value: 'es-sv' },
    { label: 'Spanish (Guatemala)', value: 'es-gt' },
    { label: 'Spanish (Honduras)', value: 'es-hn' },
    { label: 'Spanish (Mexico)', value: 'es-mx' },
    { label: 'Spanish (Nicaragua)', value: 'es-ni' },
    { label: 'Spanish (Panama)', value: 'es-pa' },
    { label: 'Spanish (Paraguay)', value: 'es-py' },
    { label: 'Spanish (Peru)', value: 'es-pe' },
    { label: 'Spanish (Puerto Rico)', value: 'es-pr' },
    { label: 'Spanish (Spain)', value: 'es-es' },
    { label: 'Spanish (Uruguay)', value: 'es-uy' },
    { label: 'Spanish (Venezuela)', value: 'es-ve' },
    { label: 'Swedish', value: 'sv' },
    { label: 'Swedish (Finland)', value: 'sv-fi' },
    { label: 'Swedish (Sweden)', value: 'sv-se' },
    { label: 'Turkish', value: 'tr' },
    { label: 'Ukranian', value: 'uk' },
  ],
  PODCAST_EPISODE_AUDIO_TYPES: {
    MOBILE_RECORDING: 'mobileRecording',
    // may be difficult to track in database (3.0 easier, or we add a special 'origin' for these files)
    UPLOAD: 'upload',
    INTERVIEW: 'interview',
    CALL_IN: 'callIn',
    INTERLUDE: 'interlude',
    LIBRARY: 'library',
  },
  PODCAST_IMPORT_ORIGIN: 'podcasts:import',
  PODCAST_IMPORT_STATUS: {
    FAILED: 'failed',
    IN_PROGRESS: 'inProgress',
    FINISHED: 'finished',
  },
  PROCESSOR_AUTH_OUTCOMES: {
    USER_HAS_NO_EMAIL: 'noEmail',
    STATION_HAS_MUSIC_IN_EPISODES: 'musicInEpisodes',
    STATION_HAS_IMPORTED_AND_NOT_REDIRECTED: 'notRedirected',
  },
  PODCAST_CATEGORIES: [
    {
      title: 'Arts',
      children: [
        'Design',
        'Fashion & Beauty',
        'Food',
        'Literature',
        'Performing Arts',
        'Visual Arts',
      ],
    },
    {
      title: 'Business',
      children: [
        'Business News',
        'Careers',
        'Investing',
        'Management & Marketing',
        'Shopping',
      ],
    },
    {
      title: 'Comedy',
      children: [],
    },
    {
      title: 'Education',
      children: [
        'Educational Technology',
        'Higher Education',
        'K-12',
        'Language Courses',
        'Training',
      ],
    },
    {
      title: 'Games & Hobbies',
      children: [
        'Automotive',
        'Aviation',
        'Hobbies',
        'Other Games',
        'Video Games',
      ],
    },
    {
      title: 'Government & Organizations',
      children: ['Local', 'National', 'Non-Profit', 'Regional'],
    },
    {
      title: 'Health',
      children: [
        'Alternative Health',
        'Fitness & Nutrition',
        'Self-Help',
        'Sexuality',
      ],
    },
    {
      title: 'Kids & Family',
      children: [],
    },
    {
      title: 'Music',
      children: [],
    },
    {
      title: 'News & Politics',
      children: [],
    },
    {
      title: 'Religion & Spirituality',
      children: [
        'Buddhism',
        'Christianity',
        'Hinduism',
        'Islam',
        'Judaism',
        'Other',
        'Spirituality',
      ],
    },
    {
      title: 'Science & Medicine',
      children: ['Medicine', 'Natural Sciences', 'Social Sciences'],
    },
    {
      title: 'Society & Culture',
      children: [
        'History',
        'Personal Journals',
        'Philosophy',
        'Places & Travel',
      ],
    },
    {
      title: 'Sports & Recreation',
      children: ['Amateur', 'College & High School', 'Outdoor', 'Professional'],
    },
    {
      title: 'Technology',
      children: ['Gadgets', 'Tech News', 'Podcasting', 'Software How-To'],
    },
    {
      title: 'TV & Film',
      children: [],
    },
  ],
});

function isClipperPath(path = '') {
  return path.indexOf('/clipper') === 0;
}

function isEmbedPath(path = '') {
  return (
    path &&
    (path.indexOf('/e/') === 0 ||
      path.match(/\/embed$/) ||
      path.match(/\/embed\/episodes\//))
  );
}

function isPodcastDashboardPath(path = '') {
  return path.indexOf('/dashboard') === 0;
}

function doHideGetAppButton(path = '') {
  const { parseUserAgent, windowUndefined } = serverRenderingUtils;
  if (windowUndefined()) {
    return false;
  }
  const { mobile } = parseUserAgent();
  if (mobile) {
    // episodes pages, as they have a high get the app button
    if (path.indexOf('/rr/') === 0) {
      return true;
    }
    // call join invitations (VOIP)
    if (path.indexOf('/call/') !== -1) {
      return true;
    }
    return false;
  }
  return false;
}

function getBaseUrl() {
  if (process.env.BASE_URL) {
    return process.env.BASE_URL;
  }
  // old way
  return {
    local: `http://localhost:${process.env.PORT || 8012}`,
    development: 'https://v2websitedev2.anchor.fm',
    staging: 'https://anchor.fm',
    production: 'https://anchor.fm',
  }[ENVIRONMENT || 'local'];
}

function getDateWithoutHours(date) {
  const dateWithoutHours = new Date(date);
  dateWithoutHours.setHours(0);
  dateWithoutHours.setMinutes(0);
  dateWithoutHours.setSeconds(0);
  dateWithoutHours.setMilliseconds(0);
  return dateWithoutHours;
}

function getBlobUrlCreator() {
  if (serverRenderingUtils.windowUndefined()) {
    return null;
  }
  const blob = window.URL || window.webkitURL;
  return blob || null;
}

function getEpisodeImage({ episode = {}, podcastMetadata = {}, creator = {} }) {
  return (
    episode.episodeImage ||
    podcastMetadata.podcastImage ||
    creator.imageUrl ||
    DEFAULT_PODCAST_IMAGE
  );
}

/**
 * Assumes dollars
 */
function calculatePayoutFee(centsInWallet = 0, isInstant = false) {
  if (isInstant) {
    const fee = Math.ceil(0.0125 * centsInWallet);
    return Math.max(fee, 50);
  }
  return 25;
}
